document.addEventListener('DOMContentLoaded', function() {
    // Находим контейнер с фильтрами
    const filtersContainer = document.querySelector('.services__filters');
    const filterButtons = document.querySelectorAll('.services__filter');
    
    // Функция обновления позиции и ширины подложки
    function updateSliderPosition(activeButton) {
        const buttonRect = activeButton.getBoundingClientRect();
        const containerRect = filtersContainer.getBoundingClientRect();
        
        // Вычисляем позицию относительно контейнера
        const leftPosition = buttonRect.left - containerRect.left;
        const buttonWidth = buttonRect.width;
        
        // Обновляем CSS переменные (если нужно)
        filtersContainer.style.setProperty('--width', `${buttonWidth}px`);
        filtersContainer.style.setProperty('--left', `${leftPosition}px`);
    }
    
    // Функция проверки, соответствует ли элемент выбранному фильтру
    function matchesFilter(item, filterValue) {
        if (filterValue === 'all') return true;
        
        const itemFilter = item.getAttribute('data-filter');
        if (!itemFilter) return false;
        
        // Разбиваем строку с категориями на массив
        const itemCategories = itemFilter.split(',').map(cat => cat.trim());
        
        // Проверяем, есть ли выбранная категория в списке категорий элемента
        return itemCategories.includes(filterValue);
    }
    
    // Функция активации фильтра
    function activateFilter(button) {
        // Удаляем активный класс у всех кнопок
        filterButtons.forEach(btn => {
            btn.classList.remove('active');
        });
        
        // Добавляем активный класс текущей кнопке
        button.classList.add('active');
        
        // Обновляем позицию подложки
        updateSliderPosition(button);
        
        // Фильтрация элементов
        const filterValue = button.getAttribute('data-filter');
        const items = document.querySelectorAll('.services__grid > *');
        
        items.forEach(item => {
            if (matchesFilter(item, filterValue)) {
                item.style.display = '';
            } else {
                item.style.display = 'none';
            }
        });
    }
    
    // Находим активную кнопку (по умолчанию "Все")
    let activeButton = document.querySelector('.services__filter.active');
    if (!activeButton) {
        activeButton = document.querySelector('.services__filter[data-filter="all"]');
        if (activeButton) {
            activeButton.classList.add('active');
        }
    }
    
    // Устанавливаем начальную позицию подложки
    if (activeButton) {
        updateSliderPosition(activeButton);
    }
    
    // Добавляем обработчики событий для всех кнопок
    filterButtons.forEach(button => {
        button.addEventListener('click', function() {
            activateFilter(this);
        });
    });
    
    // Обновляем позицию подложки при изменении размера окна
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            const currentActive = document.querySelector('.services__filter.active');
            if (currentActive) {
                updateSliderPosition(currentActive);
            }
        }, 100);
    });
});